<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: '新增預付方案',
    meta: [{ name: 'description', content: 'Add Prepaid' }],
  },
  components: {
    Layout,
    BaseSteps: () => import('@components/BaseSteps'),
    Step1: () => import('./components/Step1Basic'),
    Step2: () => import('./components/Step2Prices'),
  },
  data() {
    return {
      activeStep: 1,
      stepList: Object.freeze([
        {
          title: '基本資訊',
          description: '請填寫下方欄位',
          component: () => import('./components/Step1Basic'),
        },
        {
          title: '適用項目設定',
          description: '請選取可抵扣的購買方案',
          component: () => import('./components/Step2Prices'),
        },
      ]),
      tryingNextStep: false,
      nextStepButtonVisible: false,
      step1Data: undefined,
    }
  },
  methods: {
    async onClickNextStep(currentStep) {
      this.tryingNextStep = true
      try {
        await this.$refs.step.validate()
        switch (currentStep) {
          case 1:
            this.step1Data = this.$refs.step.submitData

            this.activeStep++
            this.tryingNextStep = false
            break

          case 2:
            try {
              await this.$store.dispatch(
                'prepaid/store',
                this.$refs.step.submitData
              )
              this.$router.push({ name: 'prepaid' })
            } catch (error) {}
            this.tryingNextStep = false
            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },

    onClickLeave() {
      this.$confirm(
        '尚未完成新增，請問是否確定離開新增預付方案？',
        '您將離開此頁面',
        {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false,
        }
      ).then(() => {
        this.$router.push({ name: 'prepaid' })
      })
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader title="新增預付方案">
      <BaseSteps slot="center" :active="activeStep" :list="stepList" />
    </BasePageHeader>
    <el-card :class="$style['card-wrapper']">
      <keep-alive>
        <component
          :is="stepList[activeStep - 1].component"
          ref="step"
          v-bind="{ 'default-value': step1Data }"
        ></component>
      </keep-alive>
    </el-card>
    <div :class="$style.footer">
      <el-button data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>
      <el-button
        data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步"
        type="primary"
        :loading="tryingNextStep"
        @click="onClickNextStep(activeStep)"
      >{{ (activeStep === 1) ? '下一步' : '建立預付方案' }}</el-button>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
